import React from "react";
import "./Filters.css"

const SEGMENTS = [
    { value: "", label: "Todos" },
    { value: "Sedan", label: "Sedán" },
    { value: "Hatchback", label: "Hatchback" },
    { value: "Pickups y Comerciales", label: "Pickups y Comerciales" },
    { value: "SUVs", label: "SUVs y Crossovers" },
];

const FilterSegment = ({ segment, setSegment }) => {
    return (
        <div>
            {/* Select para móvil */}
            <select
                className="form-select  d-md-none me-auto"
                onChange={(e) => setSegment(e.target.value || null)}
                value={segment || ""}
            >
                {SEGMENTS.map((s) => (
                    <option key={s.value} value={s.value}>{s.label}</option>
                ))}
            </select>

            {/* Botones de filtro en desktop */}
            <div className="d-flex gap-2 flex-wrap d-none d-md-flex">
                {SEGMENTS.map((s) => (
                    <button
                        key={s.value}
                        className={`btn custom-tab ${segment === (s.value || null) ? "active" : ""}`}
                        onClick={() => setSegment(s.value || null)}
                    >
                        {s.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default FilterSegment;
